import { useHistory, useLocation } from 'react-router';
import { encodeURL } from './encodeURL';

export const useOpenUrlModal = (slug) => {
    const history = useHistory();
    const { pathname } = useLocation();

    const url = `${pathname === '/' ? 'home' : pathname}/${encodeURL(slug)}`;

    return () => history.push(url);
};
